import { ColorModeScript } from '@chakra-ui/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import * as Sentry from "@sentry/react";

// Initialize Sentry for error tracking with GDPR consent compliance
const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
const cookieConsent = localStorage.getItem('cookieConsent');

// Only initialize Sentry if user has explicitly accepted cookies
// This is required for GDPR compliance - Sentry is analytical, not essential
if (sentryDSN && cookieConsent === 'accepted') {
  Sentry.init({
    dsn: sentryDSN,
    integrations: [
      // Performance monitoring (renamed in v8)
      Sentry.browserTracingIntegration({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      }),
      // Session replay for debugging (renamed in v8)
      Sentry.replayIntegration({
        maskAllText: true,  // Mask all text for privacy (GDPR)
        blockAllMedia: true, // Block all media for privacy
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.2, // Capture 100% in dev, 20% in prod

    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors

    // Environment
    environment: process.env.NODE_ENV || 'production',

    // Release version
    release: process.env.REACT_APP_RELEASE_VERSION || 'unknown',

    // Don't send PII (Personally Identifiable Information) for GDPR compliance
    beforeSend(event) {
      // Remove user data if present
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
        // Keep username for debugging but anonymize it
        if (event.user.username) {
          event.user.id = event.user.username;
          delete event.user.username;
        }
      }
      return event;
    },

    // Ignore common errors that aren't actionable
    ignoreErrors: [
      // Network errors
      'Network request failed',
      'NetworkError',
      'Failed to fetch',
      // Browser extensions
      'top.GLOBALS',
      // Random plugins/extensions
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      // Cookie consent
      'Non-Error promise rejection captured',
    ],
  });

  // Expose Sentry to window for testing in console (development only)
  if (process.env.NODE_ENV === 'development') {
    window.Sentry = Sentry;
  }
}

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ColorModeScript />
    <App />
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
